<template>
    <v-container fluid class="container-full-bg-gray">
        <v-card>
            <v-row>
                <v-col cols="12">
                    <v-card-title class="card-title-color">
                        <v-row>
                            <v-col cols="12" md="6">
                                <h3>Guidelines</h3>
                            </v-col>
                            <v-col cols="12" md="6" class="d-flex justify-end">
                                <v-btn @click="refreshList()" color="primary" icon
                                    :loading="screen_data.loadingItems">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                                <v-btn @click="$router.push({name: 'guideline-editor'})" color="primary"
                                    icon>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-col>
            </v-row>
            <v-card-text class="px-0 pt-0 card-title-footer-color">
                <v-data-table 
                    v-model="screen_data.selectedItems" 
                    :items="this.screen_data.guidelines"
                    :headers="screen_data.guidelines_headers"
                    @update:items-per-page="changeLimit"
                    @update:page="changeOffset"
                    :server-items-length="screen_data.totalItems"
                    @click:row="selectRow"
                    :loading="screen_data.loadingItems"
                    fixed-header>
                    <!-- Columnas Personalizables -->
                    <template v-for="header in screen_data.guidelines_headers" v-slot:[`item.${header.value}`]="{ item }">
                        <span class="font-color">
                            <slot v-if="(header.value == 'condition' || header.value == 'consequence') " v-bind="item">
                                {{nameToShow(item[header.value])}}
                            </slot>
                            <slot v-else :name="header.value" v-bind="item">{{item[header.value] }}</slot>
                        </span>
                    </template>
                    
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { GuidelinesApiRepo } from "../modules/guidelines/infra/GuidelinesAPIRepo";
import {VueGuidelinesListScreenData} from '../modules/guidelines/infra/VueGuidelinesScreenData'
import { GuidelinesListComponent } from "@/modules/guidelines/app/GuidelinesListComponent";

export default {
    name: "GuidelinesList",
    components: {
    },
    data() {
        const screen_data = new VueGuidelinesListScreenData();
        return {
            screen_data:screen_data,
            guidelines_list_component:null,
        };
    },
    async mounted() {
        let guidelines_repo = new GuidelinesApiRepo();
        this.guidelines_list_component = new GuidelinesListComponent(guidelines_repo, this.screen_data)
        await this.guidelines_list_component.build_function_name_translator()
        this.refreshList();
    },
    methods: {
        async refreshList() {
            await this.guidelines_list_component.refreshList();
        },
        changeLimit(value){
            this.screen_data.limit = value
            this.guidelines_list_component.refreshList()
        },
        changeOffset(value){
            this.screen_data.offset = (value-1)*this.screen_data.limit
            this.guidelines_list_component.refreshList()
        },
        selectRow(item) {
            this.$router.push({ 'name': "guideline-editor", 'params': {'guideline_id': item.id }})
        },
        nameToShow(value){
            return this.guidelines_list_component.function_name_translator[value] || value
        }
    },
};
</script>

<style scoped>

</style>../modules/guidelines/infra/VueGuidelinesScreenData